// extracted by mini-css-extract-plugin
module.exports = {"header":"BasicHeader-header-bc4b","logo":"BasicHeader-logo-bc4b"};